export const findIdPageText = {
    firstExplainText: '아이디 찾기를 원하는 경우에는',
    secondExplainText: '아래의 문의 번호로 연락바랍니다.',
    infoNumber: '문의 번호',
    phoneNumber: '031-705-1426',
};
